import React, { ReactNode } from 'react';

interface CustomStorySectionsProps {
  sections: {
    id: string;
    title: ReactNode;
    content: ReactNode;
  }[];
}

const CustomStorySections = ({ sections }: CustomStorySectionsProps) => {
  return (
    <div className="flex flex-col gap-10">
      {sections.map(({ title, id, content }) => {
        return (
          <section id={id} key={id}>
            <h2 className="mb-6 md:mb-10 text-lg md:text-3xl font-semibold text-secondary-600">
              {title}
            </h2>

            {content}
          </section>
        );
      })}
    </div>
  );
};

export default CustomStorySections;
